<template>
  <div class="app-container">
    <div class="video">
      <video width="100%" height="600" controls loop autoplay muted>
        <source src="@/assets/video/video.mp4" type="video/mp4" />
      </video>
    </div>
    <div class="sec-list sec-list-even">
      <div class="card">
        <div
          style="text-align: left;"
        >搜狗输入法诞生于2006年，于2014年发布第一个Linux版本搜狗输入法。目前搜狗输入法跨平台版本同时支持Linux/Windows/Android三大平台，Arm64/Mips64/X64三大架构，适配龙芯、兆新、飞腾、鲲鹏、麒麟、海光、申威等主流芯片，兼容麒麟软件、UOS、深度、中科方德、万里红、Ubuntu等主流操作系统。</div>
        <div>搜狗输入法跨平台版本提供全面的输入模式，包括拼音、五笔、双拼、笔画、英文，同时创新支持藏语、法语、西班牙语等多种语言的键盘输入。此外，结合信创领域的特殊办公环境，搜狗输入法跨平台版本还提供离线手写识别和语音识别，给用户提供更高效的智能输入解决方案。</div>
      </div>
    </div>
    <div class="sec-list" id="box-1">
      <div class="card">
        <div class="title">全面的输入模式</div>
        <div class="title-sub mt10 mb10">拼音（9键、26键）、五笔（86、98、新世纪）、符号、表情、多语言手写、多语音离线语音、藏语、小语种</div>
        <div class="card-item-box flex">
          <div class="card-item" v-for="(item, index) in inputImgList" :key="index">
            <img v-lazy="item.src" />
            <div>{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="sec-list sec-list-even hardware-box" id="box-2">
      <div class="card">
        <div class="title">可选的输入硬件</div>
        <div class="title-sub mt10 mb10">同时支持物理键盘和触屏模式</div>
        <div class="card-item-box flex">
          <div class="card-item" v-for="(item, index) in hardwareImgList" :key="index">
            <img v-lazy="item.src" />
            <div class="desc">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="sec-list" id="box-3">
      <div class="card">
        <div class="title">支持多种操作系统</div>
        <div class="title-sub mt10 mb10">支持多种操作系统</div>
        <div class="card-item-box flex">
          <div class="card-text-item" v-for="(item, index) in opTextList" :key="index">{{item}}</div>
        </div>
      </div>
    </div>
    <div class="sec-list" id="box-4">
      <div class="card" style="padding: 0;">
        <div class="title">支持多种CPU</div>
        <div class="card-item-box flex">
          <div
            class="card-text-item card-img-item"
            v-for="(item, index) in cpuImgList"
            :key="index"
          >
            <img v-lazy="item.src" />
          </div>
        </div>
      </div>
    </div>
    <div class="sec-list cus-box position-box" id="box-5">
      <div class="card">
        <div class="title">定制化服务</div>
        <div class="card-item-box flex">
          <div class="card-item" v-for="(item, index) in cusImgList" :key="index">
            <img v-lazy="item.src" />
            <div class="desc white title bolder">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { inputImgList, hardwareImgList, opTextList, cpuImgList, cusImgList } from './const.js'
export default {
  data() {
    return {
      inputImgList,
      hardwareImgList,
      opTextList,
      cpuImgList,
      cusImgList,
      list: [
        { backgroundColor: '#282828', width: '100%', height: '600px' },
      ],
    }
  },
}
</script>
